export default __webpack_public_path__ + "static/media/backgroundLogin.1f5d3684.png";